/**
 * Must Complete Section
 * Always-visible core actions - max 3 tasks for focus
 * UX Philosophy: Confidence-Instilling, Strategically Transparent
 */

import React from 'react';
import { AlertCircle, ArrowRight, Calendar } from 'lucide-react';
import { format, parseISO } from 'date-fns';

const MustCompleteSection = ({ tasks, onStartSession }) => {
  if (tasks.length === 0) return null;

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <div className="w-6 h-6 bg-red-500 rounded-full flex items-center justify-center">
          <AlertCircle className="w-4 h-4 text-white" />
        </div>
        <h4 className="text-sm font-bold text-slate-900">Must Complete First</h4>
      </div>

      <div className="space-y-2">
        {tasks.map(task => (
          <div
            key={task.id}
            className="bg-white rounded-lg p-4 border-2 border-red-200"
          >
            <div className="flex items-start justify-between gap-3">
              <div className="flex-1 min-w-0">
                <h5 className="text-sm font-semibold text-slate-900 mb-1">
                  {task.title || task.task_name}
                </h5>

                {/* College name if available */}
                {task.college_name && (
                  <p className="text-xs text-slate-600 mb-2">
                    {task.college_name}
                  </p>
                )}

                {/* Support reason - strategically transparent */}
                <p className="text-xs text-slate-700 mb-2">
                  {task.supportReason}
                </p>

                {/* Deadline info */}
                {(task.scheduled_date || task.due_date) && (
                  <div className="flex items-center gap-1 text-xs text-slate-600">
                    <Calendar className="w-3 h-3" />
                    <span>
                      Due: {format(parseISO(task.scheduled_date || task.due_date), 'MMM d, yyyy')}
                    </span>
                  </div>
                )}
              </div>

              {/* Status indicator */}
              <div className="flex-shrink-0">
                <div className="w-8 h-8 bg-red-50 rounded-full flex items-center justify-center">
                  <AlertCircle className="w-4 h-4 text-red-600" />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Primary CTA - Start Session */}
      <button
        onClick={onStartSession}
        className="w-full py-3 bg-red-600 text-white rounded-lg font-semibold text-sm hover:bg-red-700 transition-colors shadow-sm"
      >
        🚀 Start Catch-Up Session
      </button>
    </div>
  );
};

export default MustCompleteSection;
